// import React, { useState, useEffect, useRef } from "react";
// import { useTranslation } from "react-i18next";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faTimes,
//   faUser,
//   faCalendarAlt,
//   faSnowflake,
//   faTools,
//   faCogs,
//   faCommentAlt,
//   faCheckCircle
// } from "@fortawesome/free-solid-svg-icons";
// import axios from "axios";
// import { URL } from "../../../config";
// import "./acorderform.css";
// import { useNavigate } from "react-router-dom";

// // const API_BASE = "http://localhost:4001";

// const ACOrderForm = ({ onClose, onSubmit, formData, user, previousServitorName }) => {
//   const { t } = useTranslation();
//   const navigate = useNavigate();


//   // Lists from API
//   const [divisions, setDivisions] = useState([]); // [{Id,name,code}]
//   const [areas, setAreas] = useState([]);         // [{Id,name}]
  
//   // Selection state (ids) + names (for submit)
//   const [selectedDivisionId, setSelectedDivisionId] = useState(null);
//   const [selectedAreaId, setSelectedAreaId] = useState(null);
  
//   // Refs for first invalid field focus
//   const divisionRef = useRef(null);
//   const areaRef = useRef(null);
//   const addressRef = useRef(null);

//   const [orderData, setOrderData] = useState({
//     // city: user?.city || "",
//     address: user?.Address || "",
//     mobile: user?.mobile || "",
//   });
//   const [showSuccessPopup, setShowSuccessPopup] = useState(false);
//   const [showForm, setShowForm] = useState(true);
//   const [showBlockedPopup, setShowBlockedPopup] = useState(false);
//   const [serviceId, setServiceId] = useState(null);

//   const [errors, setErrors] = useState({ city: "", area: "", address: "" });

//   // For coupons
//   const [couponCode, setCouponCode] = useState("");
//   const [appliedCoupon, setAppliedCoupon] = useState(null);
//   const [couponError, setCouponError] = useState("");
//   const [isApplyingCoupon, setIsApplyingCoupon] = useState(false);

//   const penalty = user && user.penalty ? Number(user.penalty) : 0;
//   const basePrice = Number(formData.price) || 0;
//   // const finalPrice = user.penaltyReserved ? basePrice : basePrice + penalty;

//   const [discountValue, setDiscountValue] = useState(0);
  
//   const finalPrice = (() => {
//     const total = user.penaltyReserved ? basePrice : basePrice + penalty;
//     return Math.max(0, total - discountValue);
//   })();


//   const clearError = (key) =>
//   setErrors((e) => ({ ...e, [key]: "" }));

//   const validate = () => {
//     const errs = { city: "", area: "", address: "" };
//     if (!selectedDivisionId) errs.city = t("Please select your city");
//     if (!selectedAreaId) errs.area = t("Please select your area");
//     if (!orderData.address?.trim()) errs.address = t("Please enter your address");
//     setErrors(errs);
//     return !errs.city && !errs.area && !errs.address;
//   };

//   useEffect(() => {
//     if (user) {
//       if (user.status === "Blocked") {
//         setShowBlockedPopup(true);
//         setShowForm(false);
//       } else {
//         setOrderData({
//           city: user.city || "",
//           address: user.Address || "",
//           mobile: user.mobile || "",
//         });
//       }
//     }
//   }, [user]);

//   useEffect(() => {
//     document.body.style.overflow = "hidden";
//     return () => {
//       document.body.style.overflow = "auto";
//     };
//   }, []);

//   useEffect(() => {
//     const fetchServiceId = async () => {
//       try {
//         const { data } = await axios.get(`${URL}/services`);
//         const found = data.find(s => s.services_name.toLowerCase() === "ac service");
//         if (found) setServiceId(found.Id);
//       } catch (error) {
//         console.error("Error fetching service ID:", error);
//       }
//     };
//     fetchServiceId();
//   }, []);

//   // const handleChange = (e) => {
//   //   const { name, value } = e.target;
//   //   setOrderData((prevData) => ({
//   //     ...prevData,
//   //     [name]: value,
//   //   }));
//   // };


//   // Load active divisions
//     useEffect(() => {
//       (async () => {
//         try {
//           const { data } = await axios.get(`${URL}/locations/divisions`, { params: { countryCode: "BD" } });
//           setDivisions(data || []);
  
//           // Preselect by user.city (name)
//           if (user?.city) {
//             const match = (data || []).find(d => d.name.toLowerCase() === String(user.city).toLowerCase());
//             if (match) setSelectedDivisionId(match.Id);
//           }
//         } catch (e) {
//           console.error("Failed to load divisions:", e);
//         }
//       })();
//     }, [user?.city]);
  
//     // Load active areas when division changes
//     useEffect(() => {
//       (async () => {
//         if (!selectedDivisionId) {
//           setAreas([]);
//           setSelectedAreaId(null);
//           return;
//         }
//         try {
//           const { data } = await axios.get(`${URL}/locations/areas`, { params: { divisionId: selectedDivisionId } });
//           setAreas(data || []);
  
//           // Preselect by user.area (name)
//           if (user?.area) {
//             const match = (data || []).find(a => a.name.toLowerCase() === String(user.area).toLowerCase());
//             if (match) setSelectedAreaId(match.Id);
//           } else {
//             setSelectedAreaId(null);
//           }
//         } catch (e) {
//           console.error("Failed to load areas:", e);
//           setAreas([]);
//           setSelectedAreaId(null);
//         }
//       })();
//     }, [selectedDivisionId, user?.area]);
  
//     const handleDivisionChange = (e) => {
//       const id = e.target.value ? Number(e.target.value) : null;
//       setSelectedDivisionId(id);
//       clearError("city");
//     };
  
//     const handleAreaChange = (e) => {
//       const id = e.target.value ? Number(e.target.value) : null;
//       setSelectedAreaId(id);
//       clearError("area");
//     };
  
//     const handleAddressChange = (e) => {
//       setOrderData(prev => ({ ...prev, address: e.target.value }));
//       if (e.target.value?.trim()) clearError("address");
//     };


//   const formatDate = (dateStr) => {
//     const dateObj = new Date(dateStr);
//     const day = dateObj.getDate();
//     const month = dateObj.toLocaleString("default", { month: "short" });
//     const year = dateObj.getFullYear();
//     return `${day}-${month}-${year}`;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!serviceId) {
//       console.error("Service ID not found");
//       return;
//     }

//     if (!validate()) {
//       if (!selectedDivisionId && divisionRef.current) {
//         divisionRef.current.focus();
//         divisionRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
//       } else if (!selectedAreaId && areaRef.current) {
//         areaRef.current.focus();
//         areaRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
//       } else if (!orderData.address?.trim() && addressRef.current) {
//         addressRef.current.focus();
//         addressRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
//       }
//       return;
//   }

//     const selectedDivision = divisions.find(d => d.Id === selectedDivisionId);
//     const selectedArea = areas.find(a => a.Id === selectedAreaId);

//     const finalOrderData = {
//       userId: user.Id,
//       usercity: selectedDivision.name, 
//       userarea: selectedArea.name,    
//       useraddress: orderData.address,  

//       acType: formData.acType,
//       acTon: formData.acTon,
//       new_setup: formData.newSetup,
//       installation: formData.installation,
//       uninstallation: formData.uninstallation,
//       gas_refill: formData.gasRefill,
//       cleaning: formData.cleaning,
//       issue_checkup: formData.issueCheckup,
//       remarks: formData.remarks,
//       price: finalPrice,
//       date: formData.date,
//       time: formData.time,
//       status: "pending",
//       useSameServitor: formData.useSameServitor,
//       previousServitorId: formData.servitor_id,
//       serviceId,
//     };

//     if (appliedCoupon) {
//       finalOrderData.appliedCoupon = appliedCoupon;
//       finalOrderData.discountValue = discountValue;
//     }

//     try {
//       const token = localStorage.getItem("token");
//       const headers = { Authorization: `Bearer ${token}` };
//       const response = await axios.post(`${URL}/acservice`, finalOrderData, { headers });
//       console.log("Order placed successfully:", response.data);
//       setShowForm(false);
//       setShowSuccessPopup(true);
//     } catch (error) {
//       console.error("Error placing order:", error);
//     }
//   };


//   // === Coupon handling ===
//     const handleApplyCoupon = async () => {
//       if (!couponCode.trim()) {
//         setCouponError("Please enter a coupon code.");
//         return;
//       }
//       setIsApplyingCoupon(true);
//       setCouponError("");
//       try {
//         const res = await axios.post(`${URL}/usercoupon/apply`, {
//           userId: user.Id,
//           code: couponCode.trim(),
//         });
//         const { discountValue, code } = res.data;
//         setAppliedCoupon(code);
//         setDiscountValue(discountValue);
//         setCouponError("");
//       } catch (err) {
//         setAppliedCoupon(null);
//         setDiscountValue(0);
//         setCouponError(err?.response?.data?.message || "Invalid or expired coupon.");
//       } finally {
//         setIsApplyingCoupon(false);
//       }
//     };
  
//     const handleRemoveCoupon = async () => {
//       // try {
//       //   await axios.post(`${URL}/usercoupon/remove`, {
//       //     userId: user.Id,
//       //     code: appliedCoupon,
//       //   });
//       // } catch (err) {
//       //   console.warn("Coupon removal failed (non-blocking):", err);
//       // }
//       setAppliedCoupon(null);
//       setDiscountValue(0);
//       setCouponCode("");
//       setCouponError("");
//     };

//   const closePopup = () => {
//     setShowSuccessPopup(false);
//     onClose();
//     onSubmit();
//     navigate("/profile/orderhistory");
//   };

//   const closeBlockedPopup = () => {
//     setShowBlockedPopup(false);
//     onClose();
//   };

//   return (
//     <>
//       {showForm && (
//         <div className="acorder-modal-backdrop">
//           <div className="acorder-modal-content">
//             <div className="acorder-modal-header">
//               <h2 className="acorder-modal-title">
//                 {t("acorderform.order_form.modal.title")}
//               </h2>
//               <button
//                 className="acorder-modal-close"
//                 onClick={onClose}
//                 aria-label={t("acorderform.order_form.modal.close_button")}
//               >
//                 <FontAwesomeIcon icon={faTimes} />
//               </button>
//             </div>

//             <div className="acorder-modal-body">
//               <div className="acorder-two-column-grid">
//                 <div className="acorder-modal-card">
//                   <div className="acorder-card-body">
//                     <h3 className="acorder-card-title">
//                       <FontAwesomeIcon icon={faUser} />
//                       {t("acorderform.order_form.customer_information.title")}
//                     </h3>
//                     <div className="acorder-form-grid">
//                       <div className="acorder-form-group">
//                         <label className="acorder-form-label">
//                           {t("acorderform.order_form.customer_information.labels.name")}
//                         </label>
//                         <input
//                           type="text"
//                           className="acorder-form-control"
//                           value={`${user.FirstName} ${user.LastName}`}
//                           readOnly
//                         />
//                       </div>
//                       <div className="acorder-form-group">
//                         <label className="acorder-form-label">
//                           {t("acorderform.order_form.customer_information.labels.mobile")}
//                         </label>
//                         <input
//                           type="text"
//                           className="acorder-form-control"
//                           value={`${orderData.mobile}`}
//                           readOnly
//                         />
//                       </div>
//                       <div className="acorder-form-group">
//                         <label className="acorder-form-label">
//                           {t("acorderform.order_form.customer_information.labels.city")}
//                         </label>
//                         <select
//                           className="acorder-form-control"
//                           value={selectedDivisionId || ""}
//                           onChange={handleDivisionChange}
//                           onBlur={validate}
//                           aria-invalid={Boolean(errors.city)}
//                           aria-describedby={errors.city ? "city-error" : undefined}
//                           ref={divisionRef}
//                         >
//                           <option value="">
//                             {t("plumberorderform.order_form.customer_information.labels.city_placeholder")}
//                           </option>
//                           {divisions.map(d => (
//                             <option key={d.Id} value={d.Id}>{d.name}</option>
//                           ))}
//                         </select>
//                         {errors.city && <div id="city-error" className="field-error">{errors.city}</div>}
//                       </div>

//                       {/* Area */}
//                       <div className="acorder-form-group">
//                         <label className="acorder-form-label">
//                           {t("electricianorderform.order_form.customer_information.labels.area", "Area")}
//                         </label>
//                         <select
//                           className="acorder-form-control"
//                           value={selectedAreaId || ""}
//                           onChange={handleAreaChange}
//                           onBlur={validate}
//                           disabled={!selectedDivisionId}
//                           aria-invalid={Boolean(errors.area)}
//                           aria-describedby={errors.area ? "area-error" : undefined}
//                           ref={areaRef}
//                         >
//                           <option value="">
//                             {!selectedDivisionId ? t("Select City first") : t("Select Area")}
//                           </option>
//                           {areas.map(a => (
//                             <option key={a.Id} value={a.Id}>{a.name}</option>
//                           ))}
//                         </select>
//                         {errors.area && <div id="area-error" className="field-error">{errors.area}</div>}
//                       </div>

//                       <div className="acorder-form-group">
//                         <label className="acorder-form-label">
//                           {t("acorderform.order_form.customer_information.labels.address")}
//                         </label>
//                         <textarea
//                           name="address"
//                           className="acorder-form-control"
//                           rows="3"
//                           value={orderData.address}
//                           onChange={handleAddressChange}
//                           onBlur={validate}
//                           aria-invalid={Boolean(errors.address)}
//                           aria-describedby={errors.address ? "address-error" : undefined}
//                           ref={addressRef}
//                         />
//                         {errors.address && <div id="address-error" className="field-error">{errors.address}</div>}
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="acorder-modal-card">
//                   <div className="acorder-card-body">
//                     <h3 className="acorder-card-title">
//                       <FontAwesomeIcon icon={faCalendarAlt} />
//                       {t("acorderform.order_form.booking_details.title")}
//                     </h3>
//                     <div className="acorder-form-grid">
//                       <div className="acorder-form-group">
//                         <label className="acorder-form-label">
//                           {t("acorderform.order_form.booking_details.labels.date")}
//                         </label>
//                         <input
//                           type="text"
//                           className="acorder-form-control"
//                           value={formatDate(formData.date)}
//                           readOnly
//                         />
//                       </div>
//                       <div className="acorder-form-group">
//                         <label className="acorder-form-label">
//                           {t("acorderform.order_form.booking_details.labels.time")}
//                         </label>
//                         <input
//                           type="text"
//                           className="acorder-form-control"
//                           value={formData.time}
//                           readOnly
//                         />
//                       </div>
//                       {!user.penaltyReserved && penalty > 0 ? (
//                         <>
//                           <div className="acorder-form-group">
//                             <label className="acorder-form-label">
//                               {t("acorderform.order_form.booking_details.labels.base_price")}
//                             </label>
//                             <input
//                               type="text"
//                               className="acorder-form-control"
//                               value={`${basePrice} tk`}
//                               readOnly
//                             />
//                           </div>
//                           <div className="acorder-form-group">
//                             <label className="acorder-form-label">
//                               {t("acorderform.order_form.booking_details.labels.penalty")}
//                             </label>
//                             <input
//                               type="text"
//                               className="acorder-form-control acorder-penalty-field"
//                               value={`${penalty} tk`}
//                               readOnly
//                             />
//                           </div>
//                           <div className="acorder-form-group">
//                             <label className="acorder-form-label">
//                               {t("acorderform.order_form.booking_details.labels.total_price")}
//                             </label>
//                             <input
//                               type="text"
//                               className="acorder-form-control acorder-total-price"
//                               value={`${finalPrice} tk`}
//                               readOnly
//                             />
//                           </div>
//                         </>
//                       ) : (
//                         // <div className="acorder-form-group">
//                         //   <label className="acorder-form-label">
//                         //     {t("acorderform.order_form.booking_details.labels.total_price")}
//                         //   </label>
//                         //   <input
//                         //     type="text"
//                         //     className="acorder-form-control acorder-total-price"
//                         //     value={`${finalPrice} tk`}
//                         //     readOnly
//                         //   />
//                         // </div>


//                         // New design for dicount
//                         <div className="electricianorder-form-group">
//                         <label className="electricianorder-form-label">
//                           {t("electricianorderform.order_form.booking_details.labels.total_price")}
//                         </label>

//                         {appliedCoupon ? (
//                           <div className="electricianorder-price-discounted">
//                             <div className="electricianorder-original-price">
//                               {user.penaltyReserved
//                                 ? `${basePrice} tk`
//                                 : `${basePrice + penalty} tk`}
//                             </div>

//                             <div className="electricianorder-final-price">
//                               <span className="discounted-price">{finalPrice} tk</span>
//                               <small className="discount-label">({discountValue} tk off)</small>
//                             </div>
//                           </div>
//                         ) : (
//                           <input
//                             type="text"
//                             className="electricianorder-form-control electricianorder-total-price"
//                             value={`${finalPrice} tk`}
//                             readOnly
//                           />
//                         )}
//                       </div>

//                       )}


//                       {/* Coupon Code */}
//                       <div className="electricianorder-form-group">
//                         <label className="electricianorder-form-label">
//                           {t("electricianorderform.order_form.booking_details.labels.coupon", "Coupon Code")}
//                         </label>

//                         {appliedCoupon ? (
//                           <div className="electricianorder-coupon-applied">
//                             {/* <p>
//                               ✅ Applied: <strong>{appliedCoupon}</strong>
//                             </p> */}
//                              <p>
//                                 ✅ {t("electricianorderform.coupon.applied", "Applied")}:{" "}
//                                 <strong>{appliedCoupon}</strong>
//                               </p>
//                             <button
//                               type="button"
//                               // className="electricianorder-btn electricianorder-btn-outline"
//                               className="electricianorder-btn-removecoupon"
//                               onClick={handleRemoveCoupon}
//                             >
//                               {/* Remove */}
//                               {t("electricianorderform.coupon.remove", "Remove")}
//                             </button>
//                           </div>
//                         ) : (
//                           <div className="electricianorder-coupon-input-row">
//                             <input
//                               type="text"
//                               value={couponCode}
//                               onChange={(e) => setCouponCode(e.target.value)}
//                               placeholder={t("electricianorderform.order_form.booking_details.labels.coupon_placeholder", "Enter coupon")}
//                               className="electricianorder-form-control"
//                               disabled={isApplyingCoupon}
//                             />
//                             <button
//                               type="button"
//                               // className="electricianorder-btn electricianorder-btn-primary"
//                               className="electricianorder-btn-applycoupon"
//                               onClick={handleApplyCoupon}
//                               disabled={isApplyingCoupon}
//                             >
//                               {/* {isApplyingCoupon ? "Applying..." : "Apply"} */}
//                               {isApplyingCoupon
//                                 ? t("electricianorderform.coupon.applying", "Applying...")
//                                 : t("electricianorderform.coupon.apply", "Apply")}
//                             </button>
//                           </div>
//                         )}

//                         {/* {couponError && <div className="field-error">{couponError}</div>} */}

//                         {couponError && (
//                           <div className="field-error">
//                             {t("electricianorderform.coupon.invalid", couponError)}
//                           </div>
//                         )}

//                       </div>

                      
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="acorder-modal-card">
//                 <div className="acorder-card-body">
//                   <h3 className="acorder-card-title">
//                     {t("acorderform.order_form.service_details.title")}
//                   </h3>
//                   <div className="acorder-services-section">
//                     <div className="acorder-service-category">
//                       <h4 className="acorder-category-header">
//                         <FontAwesomeIcon icon={faSnowflake} />
//                         {t("acorderform.order_form.service_details.categories.ac_specifications.title")}
//                       </h4>
//                       <div className="acorder-services-grid">
//                         <div className="acorder-service-item">
//                           <label className="acorder-form-label">
//                             {t("acorderform.order_form.service_details.categories.ac_specifications.labels.ac_type")}
//                           </label>
//                           <div className="acorder-service-value has-value">
//                             {formData.acType || "-"}
//                           </div>
//                         </div>
//                         <div className="acorder-service-item">
//                           <label className="acorder-form-label">
//                             {t("acorderform.order_form.service_details.categories.ac_specifications.labels.ac_ton")}
//                           </label>
//                           <div className="acorder-service-value has-value">
//                             {formData.acTon || "-"}
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="acorder-service-category">
//                       <h4 className="acorder-category-header">
//                         <FontAwesomeIcon icon={faTools} />
//                         {t("acorderform.order_form.service_details.categories.setup_services.title")}
//                       </h4>
//                       <div className="acorder-services-grid">
//                         <div className="acorder-service-item">
//                           <label className="acorder-form-label">
//                             {t("acorderform.order_form.service_details.categories.setup_services.labels.new_setup")}
//                           </label>
//                           <div
//                             className={`acorder-service-value ${formData.newSetup > 0 ? "has-value" : ""}`}
//                           >
//                             {formData.newSetup}{" "}
//                             <span className="acorder-service-unit">
//                               {t(formData.newSetup === 1 ? "acorderform.order_form.service_details.unit" : "acorderform.order_form.service_details.units")}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="acorder-service-item">
//                           <label className="acorder-form-label">
//                             {t("acorderform.order_form.service_details.categories.setup_services.labels.installation")}
//                           </label>
//                           <div
//                             className={`acorder-service-value ${formData.installation > 0 ? "has-value" : ""}`}
//                           >
//                             {formData.installation}{" "}
//                             <span className="acorder-service-unit">
//                               {t(formData.installation === 1 ? "acorderform.order_form.service_details.unit" : "acorderform.order_form.service_details.units")}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="acorder-service-item">
//                           <label className="acorder-form-label">
//                             {t("acorderform.order_form.service_details.categories.setup_services.labels.uninstallation")}
//                           </label>
//                           <div
//                             className={`acorder-service-value ${formData.uninstallation > 0 ? "has-value" : ""}`}
//                           >
//                             {formData.uninstallation}{" "}
//                             <span className="acorder-service-unit">
//                               {t(formData.uninstallation === 1 ? "acorderform.order_form.service_details.unit" : "acorderform.order_form.service_details.units")}
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="acorder-service-category">
//                       <h4 className="acorder-category-header">
//                         <FontAwesomeIcon icon={faCogs} />
//                         {t("acorderform.order_form.service_details.categories.maintenance_services.title")}
//                       </h4>
//                       <div className="acorder-services-grid">
//                         <div className="acorder-service-item">
//                           <label className="acorder-form-label">
//                             {t("acorderform.order_form.service_details.categories.maintenance_services.labels.gas_refill")}
//                           </label>
//                           <div
//                             className={`acorder-service-value ${formData.gasRefill > 0 ? "has-value" : ""}`}
//                           >
//                             {formData.gasRefill}{" "}
//                             <span className="acorder-service-unit">
//                               {t(formData.gasRefill === 1 ? "acorderform.order_form.service_details.unit" : "acorderform.order_form.service_details.units")}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="acorder-service-item">
//                           <label className="acorder-form-label">
//                             {t("acorderform.order_form.service_details.categories.maintenance_services.labels.cleaning")}
//                           </label>
//                           <div
//                             className={`acorder-service-value ${formData.cleaning > 0 ? "has-value" : ""}`}
//                           >
//                             {formData.cleaning}{" "}
//                             <span className="acorder-service-unit">
//                               {t(formData.cleaning === 1 ? "acorderform.order_form.service_details.unit" : "acorderform.order_form.service_details.units")}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="acorder-service-item">
//                           <label className="acorder-form-label">
//                             {t("acorderform.order_form.service_details.categories.maintenance_services.labels.issue_checkup")}
//                           </label>
//                           <div
//                             className={`acorder-service-value ${formData.issueCheckup ? "boolean-true" : ""}`}
//                           >
//                             {t(`acorderform.order_form.service_details.boolean.${formData.issueCheckup ? "yes" : "no"}`)}
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     {formData.useSameServitor && previousServitorName && (
//                       <div className="acorder-service-category">
//                         <div className="acorder-rebook-item">
//                           <label className="acorder-label-content">
//                             <FontAwesomeIcon icon={faCheckCircle} className="acorder-rebook-icon" />
//                             {t("acorderform.order_form.rebook.label")}
//                           </label>
//                           <div className="acorder-rebook-value">
//                             <strong>{previousServitorName}</strong>
//                           </div>
//                         </div>
//                       </div>
//                     )}

//                     {formData.remarks && (
//                       <div className="acorder-remarks-item">
//                         <label className="acorder-form-label">
//                           <FontAwesomeIcon icon={faCommentAlt} className="acorder-remarks-icon" />
//                           {t("acorderform.order_form.service_details.categories.maintenance_services.labels.remarks")}
//                         </label>
//                         <div className="acorder-remarks-value has-value">
//                           {formData.remarks}
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="acorder-order-actions">
//               <button className="acorder-btn acorder-btn-outline" onClick={onClose}>
//                 {t("acorderform.order_form.actions.cancel")}
//               </button>
//               <button className="acorder-btn acorder-btn-primary" onClick={handleSubmit}>
//                 <FontAwesomeIcon icon={faTools} />
//                 {t("acorderform.order_form.actions.place_order")}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {showSuccessPopup && (
//         <div className="acorder-success-popup">
//           <div className="acorder-success-popup-content">
//             <h2>{t("acorderform.order_form.success_popup.title")}</h2>
//             <p>{t("acorderform.order_form.success_popup.message1")}</p>
//             <p>{t("acorderform.order_form.success_popup.message2")}</p>
//             <button className="acorder-btn acorder-btn-primary" onClick={closePopup}>
//               {t("acorderform.order_form.success_popup.button")}
//             </button>
//           </div>
//         </div>
//       )}

//       {showBlockedPopup && (
//         <div className="acorder-success-popup">
//           <div className="acorder-success-popup-content">
//             <h2>{t("acorderform.order_form.blocked_popup.title")}</h2>
//             <p>{t("acorderform.order_form.blocked_popup.message1")}</p>
//             <p>{t("acorderform.order_form.blocked_popup.message2")}</p>
//             <button className="acorder-btn acorder-btn-primary" onClick={closeBlockedPopup}>
//               {t("acorderform.order_form.blocked_popup.button")}
//             </button>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default ACOrderForm;







// ***** Add new service and update prices (21-oct-2025) ***** //
import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes,
  faUser,
  faCalendarAlt,
  faSnowflake,
  faTools,
  faCogs,
  faCommentAlt,
  faCheckCircle
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { URL } from "../../../config";
import "./acorderform.css";
import { useNavigate } from "react-router-dom";

// const API_BASE = "http://localhost:4001";

const ACOrderForm = ({ onClose, onSubmit, formData, user, previousServitorName }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();


  // Lists from API
  const [divisions, setDivisions] = useState([]); // [{Id,name,code}]
  const [areas, setAreas] = useState([]);         // [{Id,name}]
  
  // Selection state (ids) + names (for submit)
  const [selectedDivisionId, setSelectedDivisionId] = useState(null);
  const [selectedAreaId, setSelectedAreaId] = useState(null);
  
  // Refs for first invalid field focus
  const divisionRef = useRef(null);
  const areaRef = useRef(null);
  const addressRef = useRef(null);

  const [orderData, setOrderData] = useState({
    // city: user?.city || "",
    address: user?.Address || "",
    mobile: user?.mobile || "",
  });
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showForm, setShowForm] = useState(true);
  const [showBlockedPopup, setShowBlockedPopup] = useState(false);
  const [serviceId, setServiceId] = useState(null);

  const [errors, setErrors] = useState({ city: "", area: "", address: "" });

  // For coupons
  const [couponCode, setCouponCode] = useState("");
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [couponError, setCouponError] = useState("");
  const [isApplyingCoupon, setIsApplyingCoupon] = useState(false);

  
  const [isSubmitting, setIsSubmitting] = useState(false);
  

  // const penalty = user && user.penalty ? Number(user.penalty) : 0;
  // const basePrice = Number(formData.price) || 0;
  const basePrice = Number(formData.price) || 0;

  // const finalPrice = user.penaltyReserved ? basePrice : basePrice + penalty;

  const [discountValue, setDiscountValue] = useState(0);
  
  // const finalPrice = (() => {
  //   const total = user.penaltyReserved ? basePrice : basePrice + penalty;
  //   return Math.max(0, total - discountValue);
  // })();

  const finalPrice = Math.max(0, basePrice - discountValue);


  const clearError = (key) =>
  setErrors((e) => ({ ...e, [key]: "" }));

  const validate = () => {
    const errs = { city: "", area: "", address: "" };
    if (!selectedDivisionId) errs.city = t("Please select your city");
    if (!selectedAreaId) errs.area = t("Please select your area");
    if (!orderData.address?.trim()) errs.address = t("Please enter your address");
    setErrors(errs);
    return !errs.city && !errs.area && !errs.address;
  };

  useEffect(() => {
    if (user) {
      if (user.status === "Blocked") {
        setShowBlockedPopup(true);
        setShowForm(false);
      } else {
        setOrderData({
          city: user.city || "",
          address: user.Address || "",
          mobile: user.mobile || "",
        });
      }
    }
  }, [user]);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  useEffect(() => {
    const fetchServiceId = async () => {
      try {
        const { data } = await axios.get(`${URL}/services`);
        const found = data.find(s => s.services_name.toLowerCase() === "ac service");
        if (found) setServiceId(found.Id);
      } catch (error) {
        console.error("Error fetching service ID:", error);
      }
    };
    fetchServiceId();
  }, []);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setOrderData((prevData) => ({
  //     ...prevData,
  //     [name]: value,
  //   }));
  // };


  // Load active divisions
    useEffect(() => {
      (async () => {
        try {
          const { data } = await axios.get(`${URL}/locations/divisions`, { params: { countryCode: "BD" } });
          setDivisions(data || []);
  
          // Preselect by user.city (name)
          if (user?.city) {
            const match = (data || []).find(d => d.name.toLowerCase() === String(user.city).toLowerCase());
            if (match) setSelectedDivisionId(match.Id);
          }
        } catch (e) {
          console.error("Failed to load divisions:", e);
        }
      })();
    }, [user?.city]);
  
    // Load active areas when division changes
    useEffect(() => {
      (async () => {
        if (!selectedDivisionId) {
          setAreas([]);
          setSelectedAreaId(null);
          return;
        }
        try {
          const { data } = await axios.get(`${URL}/locations/areas`, { params: { divisionId: selectedDivisionId } });
          setAreas(data || []);
  
          // Preselect by user.area (name)
          if (user?.area) {
            const match = (data || []).find(a => a.name.toLowerCase() === String(user.area).toLowerCase());
            if (match) setSelectedAreaId(match.Id);
          } else {
            setSelectedAreaId(null);
          }
        } catch (e) {
          console.error("Failed to load areas:", e);
          setAreas([]);
          setSelectedAreaId(null);
        }
      })();
    }, [selectedDivisionId, user?.area]);
  
    const handleDivisionChange = (e) => {
      const id = e.target.value ? Number(e.target.value) : null;
      setSelectedDivisionId(id);
      clearError("city");
    };
  
    const handleAreaChange = (e) => {
      const id = e.target.value ? Number(e.target.value) : null;
      setSelectedAreaId(id);
      clearError("area");
    };
  
    const handleAddressChange = (e) => {
      setOrderData(prev => ({ ...prev, address: e.target.value }));
      if (e.target.value?.trim()) clearError("address");
    };


  const formatDate = (dateStr) => {
    const dateObj = new Date(dateStr);
    const day = dateObj.getDate();
    const month = dateObj.toLocaleString("default", { month: "short" });
    const year = dateObj.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    if (!serviceId) {
      console.error("Service ID not found");
      return;
    }

    if (!validate()) {
      if (!selectedDivisionId && divisionRef.current) {
        divisionRef.current.focus();
        divisionRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      } else if (!selectedAreaId && areaRef.current) {
        areaRef.current.focus();
        areaRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      } else if (!orderData.address?.trim() && addressRef.current) {
        addressRef.current.focus();
        addressRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      return;
  }

    const selectedDivision = divisions.find(d => d.Id === selectedDivisionId);
    const selectedArea = areas.find(a => a.Id === selectedAreaId);

    const finalOrderData = {
      userId: user.Id,
      usercity: selectedDivision.name, 
      userarea: selectedArea.name,    
      useraddress: orderData.address,  

      acType: formData.acType,
      acTon: formData.acTon,
      // new_setup: formData.newSetup,
      // installation: formData.installation,
      // uninstallation: formData.uninstallation,
      // gas_refill: formData.gasRefill,
      // cleaning: formData.cleaning,
      // issue_checkup: formData.issueCheckup,

      installation_outdoor_inside:  Number(formData.installation_outdoor_inside)  || 0,
      installation_outdoor_outside: Number(formData.installation_outdoor_outside) || 0,
      uninstallation_outdoor_inside:  Number(formData.uninstallation_outdoor_inside)  || 0,
      uninstallation_outdoor_outside: Number(formData.uninstallation_outdoor_outside) || 0,

      cleaning_outdoor_inside:  Number(formData.cleaning_outdoor_inside)  || 0,
      cleaning_outdoor_outside: Number(formData.cleaning_outdoor_outside) || 0,

      issue_checkup: Number(formData.issue_checkup) || 0,

      remarks: formData.remarks,
      price: finalPrice,
      date: formData.date,
      time: formData.time,
      status: "pending",
      useSameServitor: formData.useSameServitor,
      previousServitorId: formData.servitor_id,
      serviceId,
    };

    if (appliedCoupon) {
      finalOrderData.appliedCoupon = appliedCoupon;
      finalOrderData.discountValue = discountValue;
    }

    try {
      setIsSubmitting(true);

      const token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.post(`${URL}/acservice`, finalOrderData, { headers });
      console.log("Order placed successfully:", response.data);
      setShowForm(false);
      setShowSuccessPopup(true);
    } catch (error) {
      console.error("Error placing order:", error);
    } finally {
      setIsSubmitting(false);
    }
  };


  // === Coupon handling ===
    const handleApplyCoupon = async () => {
      if (!couponCode.trim()) {
        setCouponError("Please enter a coupon code.");
        return;
      }
      setIsApplyingCoupon(true);
      setCouponError("");
      try {
        const res = await axios.post(`${URL}/usercoupon/apply`, {
          userId: user.Id,
          code: couponCode.trim(),
        });
        const { discountValue, code } = res.data;
        setAppliedCoupon(code);
        setDiscountValue(discountValue);
        setCouponError("");
      } catch (err) {
        setAppliedCoupon(null);
        setDiscountValue(0);
        setCouponError(err?.response?.data?.message || "Invalid or expired coupon.");
      } finally {
        setIsApplyingCoupon(false);
      }
    };
  
    const handleRemoveCoupon = async () => {
      // try {
      //   await axios.post(`${URL}/usercoupon/remove`, {
      //     userId: user.Id,
      //     code: appliedCoupon,
      //   });
      // } catch (err) {
      //   console.warn("Coupon removal failed (non-blocking):", err);
      // }
      setAppliedCoupon(null);
      setDiscountValue(0);
      setCouponCode("");
      setCouponError("");
    };

  const closePopup = () => {
    setShowSuccessPopup(false);
    onClose();
    onSubmit();
    navigate("/profile/orderhistory");
  };

  const closeBlockedPopup = () => {
    setShowBlockedPopup(false);
    onClose();
  };

  return (
    <>
      {showForm && (
        <div className="acorder-modal-backdrop">
          <div className="acorder-modal-content">
            <div className="acorder-modal-header">
              <h2 className="acorder-modal-title">
                {t("acorderform.order_form.modal.title")}
              </h2>
              <button
                className="acorder-modal-close"
                onClick={onClose}
                aria-label={t("acorderform.order_form.modal.close_button")}
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>

            <div className="acorder-modal-body">
              <div className="acorder-two-column-grid">
                <div className="acorder-modal-card">
                  <div className="acorder-card-body">
                    <h3 className="acorder-card-title">
                      <FontAwesomeIcon icon={faUser} />
                      {t("acorderform.order_form.customer_information.title")}
                    </h3>
                    <div className="acorder-form-grid">
                      <div className="acorder-form-group">
                        <label className="acorder-form-label">
                          {t("acorderform.order_form.customer_information.labels.name")}
                        </label>
                        <input
                          type="text"
                          className="acorder-form-control"
                          value={`${user.FirstName} ${user.LastName}`}
                          readOnly
                        />
                      </div>
                      <div className="acorder-form-group">
                        <label className="acorder-form-label">
                          {t("acorderform.order_form.customer_information.labels.mobile")}
                        </label>
                        <input
                          type="text"
                          className="acorder-form-control"
                          value={`${orderData.mobile}`}
                          readOnly
                        />
                      </div>
                      <div className="acorder-form-group">
                        <label className="acorder-form-label">
                          {t("acorderform.order_form.customer_information.labels.city")}
                        </label>
                        <select
                          className="acorder-form-control"
                          value={selectedDivisionId || ""}
                          onChange={handleDivisionChange}
                          onBlur={validate}
                          aria-invalid={Boolean(errors.city)}
                          aria-describedby={errors.city ? "city-error" : undefined}
                          ref={divisionRef}
                        >
                          <option value="">
                            {t("plumberorderform.order_form.customer_information.labels.city_placeholder")}
                          </option>
                          {divisions.map(d => (
                            <option key={d.Id} value={d.Id}>{d.name}</option>
                          ))}
                        </select>
                        {errors.city && <div id="city-error" className="field-error">{errors.city}</div>}
                      </div>

                      {/* Area */}
                      <div className="acorder-form-group">
                        <label className="acorder-form-label">
                          {t("electricianorderform.order_form.customer_information.labels.area", "Area")}
                        </label>
                        <select
                          className="acorder-form-control"
                          value={selectedAreaId || ""}
                          onChange={handleAreaChange}
                          onBlur={validate}
                          disabled={!selectedDivisionId}
                          aria-invalid={Boolean(errors.area)}
                          aria-describedby={errors.area ? "area-error" : undefined}
                          ref={areaRef}
                        >
                          <option value="">
                            {!selectedDivisionId ? t("Select City first") : t("Select Area")}
                          </option>
                          {areas.map(a => (
                            <option key={a.Id} value={a.Id}>{a.name}</option>
                          ))}
                        </select>
                        {errors.area && <div id="area-error" className="field-error">{errors.area}</div>}
                      </div>

                      <div className="acorder-form-group">
                        <label className="acorder-form-label">
                          {t("acorderform.order_form.customer_information.labels.address")}
                        </label>
                        <textarea
                          name="address"
                          className="acorder-form-control"
                          rows="3"
                          value={orderData.address}
                          onChange={handleAddressChange}
                          onBlur={validate}
                          aria-invalid={Boolean(errors.address)}
                          aria-describedby={errors.address ? "address-error" : undefined}
                          ref={addressRef}
                        />
                        {errors.address && <div id="address-error" className="field-error">{errors.address}</div>}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="acorder-modal-card">
                  <div className="acorder-card-body">
                    <h3 className="acorder-card-title">
                      <FontAwesomeIcon icon={faCalendarAlt} />
                      {t("acorderform.order_form.booking_details.title")}
                    </h3>
                    <div className="acorder-form-grid">
                      <div className="acorder-form-group">
                        <label className="acorder-form-label">
                          {t("acorderform.order_form.booking_details.labels.date")}
                        </label>
                        <input
                          type="text"
                          className="acorder-form-control"
                          value={formatDate(formData.date)}
                          readOnly
                        />
                      </div>
                      <div className="acorder-form-group">
                        <label className="acorder-form-label">
                          {t("acorderform.order_form.booking_details.labels.time")}
                        </label>
                        <input
                          type="text"
                          className="acorder-form-control"
                          value={formData.time}
                          readOnly
                        />
                      </div>
                      {/* {!user.penaltyReserved && penalty > 0 ? (
                        <>
                          <div className="acorder-form-group">
                            <label className="acorder-form-label">
                              {t("acorderform.order_form.booking_details.labels.base_price")}
                            </label>
                            <input
                              type="text"
                              className="acorder-form-control"
                              value={`${basePrice} tk`}
                              readOnly
                            />
                          </div>
                          <div className="acorder-form-group">
                            <label className="acorder-form-label">
                              {t("acorderform.order_form.booking_details.labels.penalty")}
                            </label>
                            <input
                              type="text"
                              className="acorder-form-control acorder-penalty-field"
                              value={`${penalty} tk`}
                              readOnly
                            />
                          </div>
                          <div className="acorder-form-group">
                            <label className="acorder-form-label">
                              {t("acorderform.order_form.booking_details.labels.total_price")}
                            </label>
                            <input
                              type="text"
                              className="acorder-form-control acorder-total-price"
                              value={`${finalPrice} tk`}
                              readOnly
                            />
                          </div>
                        </>
                      ) : (
                        
                        // New design for dicount
                        <div className="electricianorder-form-group">
                        <label className="electricianorder-form-label">
                          {t("electricianorderform.order_form.booking_details.labels.total_price")}
                        </label>

                        {appliedCoupon ? (
                          <div className="electricianorder-price-discounted">
                            <div className="electricianorder-original-price">
                              {user.penaltyReserved
                                ? `${basePrice} tk`
                                : `${basePrice + penalty} tk`}
                            </div>

                            <div className="electricianorder-final-price">
                              <span className="discounted-price">{finalPrice} tk</span>
                              <small className="discount-label">({discountValue} tk off)</small>
                            </div>
                          </div>
                        ) : (
                          <input
                            type="text"
                            className="electricianorder-form-control electricianorder-total-price"
                            value={`${finalPrice} tk`}
                            readOnly
                          />
                        )}
                      </div>

                      )} */}

                      <div className="electricianorder-form-group">
                        <label className="electricianorder-form-label">
                          {t("electricianorderform.order_form.booking_details.labels.total_price")}
                        </label>

                        {appliedCoupon ? (
                          <div className="electricianorder-price-discounted">
                            <div className="electricianorder-original-price">
                              {basePrice} tk
                            </div>

                            <div className="electricianorder-final-price">
                              <span className="discounted-price">{finalPrice} tk</span>
                              <small className="discount-label">({discountValue} tk off)</small>
                            </div>
                          </div>
                        ) : (
                          <input
                            type="text"
                            className="electricianorder-form-control electricianorder-total-price"
                            value={`${finalPrice} tk`}
                            readOnly
                          />
                        )}
                      </div>



                      {/* Coupon Code */}
                      <div className="electricianorder-form-group">
                        <label className="electricianorder-form-label">
                          {t("electricianorderform.order_form.booking_details.labels.coupon", "Coupon Code")}
                        </label>

                        {appliedCoupon ? (
                          <div className="electricianorder-coupon-applied">
                            {/* <p>
                              ✅ Applied: <strong>{appliedCoupon}</strong>
                            </p> */}
                             <p>
                                ✅ {t("electricianorderform.coupon.applied", "Applied")}:{" "}
                                <strong>{appliedCoupon}</strong>
                              </p>
                            <button
                              type="button"
                              // className="electricianorder-btn electricianorder-btn-outline"
                              className="electricianorder-btn-removecoupon"
                              onClick={handleRemoveCoupon}
                            >
                              {/* Remove */}
                              {t("electricianorderform.coupon.remove", "Remove")}
                            </button>
                          </div>
                        ) : (
                          <div className="electricianorder-coupon-input-row">
                            <input
                              type="text"
                              value={couponCode}
                              onChange={(e) => setCouponCode(e.target.value)}
                              placeholder={t("electricianorderform.order_form.booking_details.labels.coupon_placeholder", "Enter coupon")}
                              className="electricianorder-form-control"
                              disabled={isApplyingCoupon}
                            />
                            <button
                              type="button"
                              // className="electricianorder-btn electricianorder-btn-primary"
                              className="electricianorder-btn-applycoupon"
                              onClick={handleApplyCoupon}
                              disabled={isApplyingCoupon}
                            >
                              {/* {isApplyingCoupon ? "Applying..." : "Apply"} */}
                              {isApplyingCoupon
                                ? t("electricianorderform.coupon.applying", "Applying...")
                                : t("electricianorderform.coupon.apply", "Apply")}
                            </button>
                          </div>
                        )}

                        {/* {couponError && <div className="field-error">{couponError}</div>} */}

                        {couponError && (
                          <div className="field-error">
                            {t("electricianorderform.coupon.invalid", couponError)}
                          </div>
                        )}

                      </div>

                      
                    </div>
                  </div>
                </div>
              </div>

              <div className="acorder-modal-card">
                <div className="acorder-card-body">
                  <h3 className="acorder-card-title">
                    {t("acorderform.order_form.service_details.title")}
                  </h3>
                  <div className="acorder-services-section">
                    <div className="acorder-service-category">
                      <h4 className="acorder-category-header">
                        <FontAwesomeIcon icon={faSnowflake} />
                        {t("acorderform.order_form.service_details.categories.ac_specifications.title")}
                      </h4>
                      <div className="acorder-services-grid">
                        <div className="acorder-service-item">
                          <label className="acorder-form-label">
                            {t("acorderform.order_form.service_details.categories.ac_specifications.labels.ac_type")}
                          </label>
                          <div className="acorder-service-value has-value">
                            {formData.acType || "-"}
                          </div>
                        </div>
                        <div className="acorder-service-item">
                          <label className="acorder-form-label">
                            {t("acorderform.order_form.service_details.categories.ac_specifications.labels.ac_ton")}
                          </label>
                          <div className="acorder-service-value has-value">
                            {formData.acTon || "-"}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* <div className="acorder-service-category">
                      <h4 className="acorder-category-header">
                        <FontAwesomeIcon icon={faTools} />
                        {t("acorderform.order_form.service_details.categories.setup_services.title")}
                      </h4>
                      <div className="acorder-services-grid">
                        <div className="acorder-service-item">
                          <label className="acorder-form-label">
                            {t("acorderform.order_form.service_details.categories.setup_services.labels.new_setup")}
                          </label>
                          <div
                            className={`acorder-service-value ${formData.newSetup > 0 ? "has-value" : ""}`}
                          >
                            {formData.newSetup}{" "}
                            <span className="acorder-service-unit">
                              {t(formData.newSetup === 1 ? "acorderform.order_form.service_details.unit" : "acorderform.order_form.service_details.units")}
                            </span>
                          </div>
                        </div>
                        <div className="acorder-service-item">
                          <label className="acorder-form-label">
                            {t("acorderform.order_form.service_details.categories.setup_services.labels.installation")}
                          </label>
                          <div
                            className={`acorder-service-value ${formData.installation > 0 ? "has-value" : ""}`}
                          >
                            {formData.installation}{" "}
                            <span className="acorder-service-unit">
                              {t(formData.installation === 1 ? "acorderform.order_form.service_details.unit" : "acorderform.order_form.service_details.units")}
                            </span>
                          </div>
                        </div>
                        <div className="acorder-service-item">
                          <label className="acorder-form-label">
                            {t("acorderform.order_form.service_details.categories.setup_services.labels.uninstallation")}
                          </label>
                          <div
                            className={`acorder-service-value ${formData.uninstallation > 0 ? "has-value" : ""}`}
                          >
                            {formData.uninstallation}{" "}
                            <span className="acorder-service-unit">
                              {t(formData.uninstallation === 1 ? "acorderform.order_form.service_details.unit" : "acorderform.order_form.service_details.units")}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div> */}


                    {/* ✅ UPDATED Setup services list */}
<div className="acorder-service-category">
  <h4 className="acorder-category-header">
    <FontAwesomeIcon icon={faTools} />
    {t("acorderform.order_form.service_details.categories.setup_services.title")}
  </h4>
  <div className="acorder-services-grid">
    {/* Install (Indoor) */}
    <div className="acorder-service-item">
      <label className="acorder-form-label">
        {/* AC Install (Outdoor Unit Inside) */}
        {t("acorderform.order_form.service_details.categories.setup_services.labels.install_outdoor_inside", "AC Install (Outdoor Unit Inside)")}
      </label>
      <div
        className={`acorder-service-value ${
          (formData.installation_outdoor_inside || 0) > 0 ? "has-value" : ""
        }`}
      >
        {formData.installation_outdoor_inside || 0}{" "}
        <span className="acorder-service-unit">
          {t(
            (formData.installation_outdoor_inside || 0) === 1
              ? "acorderform.order_form.service_details.unit"
              : "acorderform.order_form.service_details.units"
          )}
        </span>
      </div>
    </div>

    {/* Install (Outdoor) */}
    <div className="acorder-service-item">
      <label className="acorder-form-label">
        {/* AC Install (Outdoor Unit Outside) */}
        {t("acorderform.order_form.service_details.categories.setup_services.labels.install_outdoor_outside", "AC Install (Outdoor Unit Outside)")}
      </label>
      <div
        className={`acorder-service-value ${
          (formData.installation_outdoor_outside || 0) > 0 ? "has-value" : ""
        }`}
      >
        {formData.installation_outdoor_outside || 0}{" "}
        <span className="acorder-service-unit">
          {t(
            (formData.installation_outdoor_outside || 0) === 1
              ? "acorderform.order_form.service_details.unit"
              : "acorderform.order_form.service_details.units"
          )}
        </span>
      </div>
    </div>

    {/* Uninstall (Indoor) */}
    <div className="acorder-service-item">
      <label className="acorder-form-label">
        {/* AC Uninstall (Outdoor Unit Inside) */}
        {t("acorderform.order_form.service_details.categories.setup_services.labels.uninstall_outdoor_inside", "AC Uninstall (Outdoor Unit Inside)")}
      </label>
      <div
        className={`acorder-service-value ${
          (formData.uninstallation_outdoor_inside || 0) > 0 ? "has-value" : ""
        }`}
      >
        {formData.uninstallation_outdoor_inside || 0}{" "}
        <span className="acorder-service-unit">
          {t(
            (formData.uninstallation_outdoor_inside || 0) === 1
              ? "acorderform.order_form.service_details.unit"
              : "acorderform.order_form.service_details.units"
          )}
        </span>
      </div>
    </div>

    {/* Uninstall (Outdoor) */}
    <div className="acorder-service-item">
      <label className="acorder-form-label">
        {/* AC Uninstall (Outdoor Unit Outside) */}
        {t("acorderform.order_form.service_details.categories.setup_services.labels.uninstall_outdoor_outside", "AC Uninstall (Outdoor Unit Outside)")}
      </label>
      <div
        className={`acorder-service-value ${
          (formData.uninstallation_outdoor_outside || 0) > 0 ? "has-value" : ""
        }`}
      >
        {formData.uninstallation_outdoor_outside || 0}{" "}
        <span className="acorder-service-unit">
          {t(
            (formData.uninstallation_outdoor_outside || 0) === 1
              ? "acorderform.order_form.service_details.unit"
              : "acorderform.order_form.service_details.units"
          )}
        </span>
      </div>
    </div>
  </div>
</div>

                    {/* <div className="acorder-service-category">
                      <h4 className="acorder-category-header">
                        <FontAwesomeIcon icon={faCogs} />
                        {t("acorderform.order_form.service_details.categories.maintenance_services.title")}
                      </h4>
                      <div className="acorder-services-grid">
                        <div className="acorder-service-item">
                          <label className="acorder-form-label">
                            {t("acorderform.order_form.service_details.categories.maintenance_services.labels.gas_refill")}
                          </label>
                          <div
                            className={`acorder-service-value ${formData.gasRefill > 0 ? "has-value" : ""}`}
                          >
                            {formData.gasRefill}{" "}
                            <span className="acorder-service-unit">
                              {t(formData.gasRefill === 1 ? "acorderform.order_form.service_details.unit" : "acorderform.order_form.service_details.units")}
                            </span>
                          </div>
                        </div>
                        <div className="acorder-service-item">
                          <label className="acorder-form-label">
                            {t("acorderform.order_form.service_details.categories.maintenance_services.labels.cleaning")}
                          </label>
                          <div
                            className={`acorder-service-value ${formData.cleaning > 0 ? "has-value" : ""}`}
                          >
                            {formData.cleaning}{" "}
                            <span className="acorder-service-unit">
                              {t(formData.cleaning === 1 ? "acorderform.order_form.service_details.unit" : "acorderform.order_form.service_details.units")}
                            </span>
                          </div>
                        </div>
                        <div className="acorder-service-item">
                          <label className="acorder-form-label">
                            {t("acorderform.order_form.service_details.categories.maintenance_services.labels.issue_checkup")}
                          </label>
                          <div
                            className={`acorder-service-value ${formData.issueCheckup ? "boolean-true" : ""}`}
                          >
                            {t(`acorderform.order_form.service_details.boolean.${formData.issueCheckup ? "yes" : "no"}`)}
                          </div>
                        </div>
                      </div>
                    </div> */}

                    {/* ✅ UPDATED Maintenance services list */}
<div className="acorder-service-category">
  <h4 className="acorder-category-header">
    <FontAwesomeIcon icon={faCogs} />
    {t("acorderform.order_form.service_details.categories.maintenance_services.title")}
  </h4>
  <div className="acorder-services-grid">
    {/* Cleaning (Indoor) */}
    <div className="acorder-service-item">
      <label className="acorder-form-label">
        {/* AC Cleaning (Outdoor Unit Inside) */}
        {t("acorderform.order_form.service_details.categories.maintenance_services.labels.cleaning_outdoor_inside", "AC Cleaning (Outdoor Unit Inside)")}
      </label>
      <div
        className={`acorder-service-value ${
          (formData.cleaning_outdoor_inside || 0) > 0 ? "has-value" : ""
        }`}
      >
        {formData.cleaning_outdoor_inside || 0}{" "}
        <span className="acorder-service-unit">
          {t(
            (formData.cleaning_outdoor_inside || 0) === 1
              ? "acorderform.order_form.service_details.unit"
              : "acorderform.order_form.service_details.units"
          )}
        </span>
      </div>
    </div>

    {/* Cleaning (Outdoor) */}
    <div className="acorder-service-item">
      <label className="acorder-form-label">
        {/* AC Cleaning (Outdoor Unit Outside) */}
        {t("acorderform.order_form.service_details.categories.maintenance_services.labels.cleaning_outdoor_outside", "AC Cleaning (Outdoor Unit Outside)")}
      </label>
      <div
        className={`acorder-service-value ${
          (formData.cleaning_outdoor_outside || 0) > 0 ? "has-value" : ""
        }`}
      >
        {formData.cleaning_outdoor_outside || 0}{" "}
        <span className="acorder-service-unit">
          {t(
            (formData.cleaning_outdoor_outside || 0) === 1
              ? "acorderform.order_form.service_details.unit"
              : "acorderform.order_form.service_details.units"
          )}
        </span>
      </div>
    </div>

    {/* Issue Checkup (units) */}
    <div className="acorder-service-item">
      <label className="acorder-form-label">
        {t("acorderform.order_form.service_details.categories.maintenance_services.labels.issue_checkup")}
      </label>
      <div
        className={`acorder-service-value ${
          (formData.issue_checkup || 0) > 0 ? "has-value" : ""
        }`}
      >
        {Number(formData.issue_checkup) || 0}{" "}
        <span className="acorder-service-unit">
          {t(
            (Number(formData.issue_checkup) || 0) === 1
              ? "acorderform.order_form.service_details.unit"
              : "acorderform.order_form.service_details.units"
          )}
        </span>
      </div>
    </div>
  </div>
</div>

                    {formData.useSameServitor && previousServitorName && (
                      <div className="acorder-service-category">
                        <div className="acorder-rebook-item">
                          <label className="acorder-label-content">
                            <FontAwesomeIcon icon={faCheckCircle} className="acorder-rebook-icon" />
                            {t("acorderform.order_form.rebook.label")}
                          </label>
                          <div className="acorder-rebook-value">
                            <strong>{previousServitorName}</strong>
                          </div>
                        </div>
                      </div>
                    )}

                    {formData.remarks && (
                      <div className="acorder-remarks-item">
                        <label className="acorder-form-label">
                          <FontAwesomeIcon icon={faCommentAlt} className="acorder-remarks-icon" />
                          {t("acorderform.order_form.service_details.categories.maintenance_services.labels.remarks")}
                        </label>
                        <div className="acorder-remarks-value has-value">
                          {formData.remarks}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="acorder-order-actions">
              <button className="acorder-btn acorder-btn-outline" onClick={onClose}>
                {t("acorderform.order_form.actions.cancel")}
              </button>
              <button className="acorder-btn acorder-btn-primary" onClick={handleSubmit} disabled={isSubmitting}>
                <FontAwesomeIcon icon={faTools} />
                {/* {t("acorderform.order_form.actions.place_order")} */}

                {isSubmitting
                  ? t("acorderform.order_form.actions.placing", "Placing...")
                  : t("acorderform.order_form.actions.place_order")}

              </button>
            </div>
          </div>
        </div>
      )}

      {showSuccessPopup && (
        <div className="acorder-success-popup">
          <div className="acorder-success-popup-content">
            <h2>{t("acorderform.order_form.success_popup.title")}</h2>
            <p>{t("acorderform.order_form.success_popup.message1")}</p>
            <p>{t("acorderform.order_form.success_popup.message2")}</p>
            <button className="acorder-btn acorder-btn-primary" onClick={closePopup}>
              {t("acorderform.order_form.success_popup.button")}
            </button>
          </div>
        </div>
      )}

      {showBlockedPopup && (
        <div className="acorder-success-popup">
          <div className="acorder-success-popup-content">
            <h2>{t("acorderform.order_form.blocked_popup.title")}</h2>
            <p>{t("acorderform.order_form.blocked_popup.message1")}</p>
            <p>{t("acorderform.order_form.blocked_popup.message2")}</p>
            <button className="acorder-btn acorder-btn-primary" onClick={closeBlockedPopup}>
              {t("acorderform.order_form.blocked_popup.button")}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ACOrderForm;